<template>
  <b-form @keydown="form.errors.clear()" @submit.prevent="onSubmit">
    <div class="row">
      <div class="col">
        <b-card class="mb-3">
          <template #header>Work Areas for {{ currentUser.name }}</template>

          <form-textarea v-model="form.tier_0" name="tier_0">
            Tier 0<br />
            Territory
          </form-textarea>

          <div class="mb-3">
            <div class="row mb-2">
              <div class="col-3"></div>
              <div class="col-8 text-right">
                <a :href="mapUrl" target="_blank">
                  <font-awesome-icon :icon="['fal', 'map-marked']" />
                  <small> Map Overview</small>
                </a>
              </div>
            </div>

            <form-textarea v-model="form.tier_1" name="tier_1" @input="updateMapUrl" />
            <form-textarea v-model="form.tier_2" name="tier_2" />
            <form-textarea v-model="form.tier_3" name="tier_3" />

            <div class="row" style="margin-top: -12px">
              <div class="col-3"></div>
              <div class="col-8 text-right">
                <small class="text-muted">Postcodes separated by comma</small>
              </div>
            </div>
          </div>

          <div class="text-right">
            <button :disabled="form.notReady()" class="btn btn-primary">
              <font-awesome-icon v-if="form.busy" :icon="['fal', 'spinner']" spin />
              <font-awesome-icon v-else :icon="['fal', 'check']" />
              Save
            </button>
          </div>
        </b-card>
      </div>
    </div>
  </b-form>
</template>

<script type="text/babel">
import externals from "../../../constants/externals";
import EventBus from "../../../imports/event-bus";

export default {
  props: {
    currentUser: {
      required: true,
    },
  },

  data() {
    return {
      mapUrl: "",

      form: new window.AppForm({
        user_id: null,
        tier_0: null,
        tier_1: null,
        tier_2: null,
        tier_3: null,
      }),
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.form.user_id = this.currentUser.id;

      this.$http.get(`/users/${this.currentUser.id}/work-areas`).then((response) => {
        this.form.tier_0 = response.body.tier_0;
        this.form.tier_1 = response.body.tier_1;
        this.form.tier_2 = response.body.tier_2;
        this.form.tier_3 = response.body.tier_3;

        this.updateMapUrl();

        this.form.finishProcessing();
      });
    },

    onSubmit() {
      this.form.post("/work-areas").then(() => {
        EventBus.$emit("user-updated");

        this.init();
        window.toastr.success("Work Areas updated!", "Success");
      });
    },

    updateMapUrl() {
      const tier0 = this.form.tier_0.replace(/\s/g, "");
      const tier1 = this.form.tier_1.replace(/\s/g, "");
      const tier2 = this.form.tier_2.replace(/\s/g, "");
      const tier3 = this.form.tier_3.replace(/\s/g, "");
      const name = this.currentUser.name;
      const brand = this.$lodash.get(this.currentUser, "brands[0].name");

      this.mapUrl = encodeURI(
        `${externals.mapit.url}&tier_0=${tier0}&tier_1=${tier1}&tier_2=${tier2}&tier_3=${tier3}&name=${name}&brand=${brand}`
      );
    },
  },
};
</script>
